export const testCaseMappingExpanded = [
  {
    display_name: "Expand",
    key: "open_modal",
    headerStyles: {
      height:"50px",
      background: "#7593F2",
      padding: "4px 8px",
      color: "white",
      
      width: '60px'
    },
    _config: {
      type: "icon",
      value: "open_in_new",
      isClickable: true,
      displayInColumn: false,
    },
  },
  {
    display_name: "User Story Id",
    key: "userStoryId",
    headerStyles: {
      background: "#7593F2",
      padding: "4px 8px",
      
      color: "white",
      width: '10%'
    },
  },
  {
    display_name: "User Story Description",
    key: "userStoryDescription",
    headerStyles: {
      background: "#7593F2",
      padding: "4px 8px",
      
      color: "white",
      width: '25%'
    },
  },
  {
    display_name: "Test Case Id",
    key: "testCaseID",
    headerStyles: {
      background: "#7593F2",
      padding: "4px 8px",
      color: "white",
      
      width: '10%'
    },
  },
  {
    display_name: "Test Case Title",
    key: "testScenario",
    headerStyles: {
      background: "#7593F2",
      padding: "4px 8px",
      color: "white",
      
      width: '25%'
    },
  },
  {
    display_name: "Source Code Path",
    key: "sourceCodePath",
    headerStyles: {
      background: "#7593F2",
      padding: "4px 8px",
      
      color: "white",
      width: '25%'
    },
  },
  {
    display_name: "Method Name",
    key: "methodName",
    headerStyles: {
      background: "#7593F2",
      padding: "4px 8px",
      
      color: "white",
      width: '20%'
    },
  }
];

export const testCaseDetailed = [
  {
    display_name: "Prerequisites",
    key: "prerequisites",
    cellStyles: {
      'align-content': 'baseline'
    },
    headerStyles: {
      background: "#7593F2",
      padding: "4px 8px",
      color: "white",
      width: '33%'
    }
  },
  {
    display_name: "Test Steps",
    key: "testSteps",
    cellStyles: {
      'align-content': 'baseline'
    },
    headerStyles: {
      background: "#7593F2",
      padding: "4px 8px",
      color: "white",
      width: '33%'
    }
  },
  {
    display_name: "Expected Results",
    key: "expectedResults",
    cellStyles: {
      'align-content': 'baseline'
    },
    headerStyles: {
      background: "#7593F2",
      padding: "4px 8px",
      color: "white",
      width: '33%'
    }
  }
];

